import React, { useEffect, useState } from 'react';
import {
    Grid,
    Box,
    Typography,
    TextField,
    Divider,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import { CloseIcon, PlusIcon } from '../../../assets';
import { CustomReactSelect, CustomButton, CustomAccordion } from '../../shared';
import { addOptions } from './constants';
import QueryBuilders from './queryBuilder';
import { useDispatch, useSelector } from 'react-redux';
import { createTrigger, getQueryPreview, updateTriggerById } from '../../../redux/thunks/triggerThunk';
import QueryAuditHistory from './queryAuditHistory';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForm, useController } from 'react-hook-form';
import { validateForScriptTag } from '../../../utility';
import { actions } from '../../../redux/reducers/queriesReducer';

const initialValue = {
    name:''
}
const queryValidation = yup.object().shape({
    name: yup.string().required('Please Enter Query Name').test('no-script-tag', 'Script tags are not allowed.', validateForScriptTag),
});
function CreateQuery(props) {
    const { handleClose } = props;
    const { company } = useSelector(state => state.company);
    const { preview, total_preview, title, query } = useSelector(state => state.query);
    const [expanded, setExpanded] = useState(false);
    const [queryRows, setQueryRows] = useState([{ id: Date.now(), condition: 'and', agg_function: 'last', agg_days: 7 }]);
    const [data, setData] = useState({
        name:'',
        definitions:[],
    });
    const dispatch = useDispatch();
    const { register, handleSubmit, setValue, getValues, formState: { errors }, control, } = useForm({ resolver: yupResolver(queryValidation), defaultValues: initialValue });
    const handleShowQueriesPreview = () => {
        setExpanded(!expanded);
    };
    useEffect(()=>{
        if(title === "Edit query" && Object.keys(query).length>0){
            dispatch(actions.resetQueryData());
            const definition = []
            const queryData = []
            query.definitions?.map((items)=>{
                definition.push({
                    id: items.id,
                    agg_days: items.agg_days,
                    agg_function: items.agg_function,
                    condition: items.condition,
                    data_input: items.data_input,
                    operator: items.operator,
                    value:items.value
                })
                queryData.push({
                    id: items.id, 
                    condition: items.condition, 
                    agg_function: items.agg_function, 
                    agg_days: items.agg_days, 
                    value:items.value,
                    operator: items.operator,
                    data_input: items.data_input,
                })
            })
            setData({
                ...data, id:query.id, name: query.name, definitions: definition
            })
            setValue("name",query.name)
            setQueryRows(queryData);

        }
    },[title, query])

    const addRow = (option) => {
        setQueryRows((prevRows) => [
            ...prevRows,
            {
                id: Date.now(),
                condition: option ? option.value : 'and',
                agg_function: 'last',
                agg_days: 7,
            },
        ]);
    };
    const deleteRow = (id) => {
        setQueryRows((prevRows) => prevRows.filter((row) => row.id !== id));
        setData({
            ...data,
            definitions: data.definitions.filter(row => row.id !== id)
          });          
    };

    const handleRowChange = (changedRow) => {
        const updatedRows = queryRows?.map((row) =>
            row.id === changedRow.id ? changedRow : row
        );
        setQueryRows(updatedRows);
        setData({...data, definitions: updatedRows})
    };
    const handleNameChange = (value) =>{
        setData({...data,name: value})
    }
    useEffect(() => {
        if (data.definitions.length > 0) {
            dispatch(getQueryPreview({ companyId: company.id, data: data }))
        }
    }, [queryRows])
    const onSubmit = (name) =>{
        if(title === "Edit query"){
            dispatch(updateTriggerById({companyId: company.id, triggerId: data.id, data: {...data,name:name.name}})).then(result => {
                if(result.payload?.status_code === 200){
                    handleClose()
                }
            })
        }
        else if(title === "Create new query"){
            dispatch(createTrigger({companyId: company.id, data: {...data,name:name.name}})).then(result => {
                if(result.payload?.status_code === 200){
                    handleClose()
                }
            })
        }
    }
    const handleSave = () => {
        handleSubmit(onSubmit);
    };

    const renderPreviewTable = () =>{
        return (
             <Box>
             <TableContainer component={Paper} className='no-box-shadow no-border'>
                 <Table className='table-border-collapse no-border'>
                     <TableHead 
                         className='queries-table-heading' 
                         sx={{
                             '& .MuiTableCell-root' : {
                                 borderBottom: 'none',
                             },
                         }}
                     >
                         <TableRow className="bg-white no-border">
                             <TableCell className="table-headers-title">ID</TableCell>
                             <TableCell className="table-headers-title">Name</TableCell>
                             <TableCell className="table-headers-title">City</TableCell>
                             <TableCell className="table-headers-title">State</TableCell>
                             <TableCell className="table-headers-title">District</TableCell>
                         </TableRow>
                     </TableHead>
                     <TableBody>
                         {preview.length>0 && preview?.map((row, index) => (
                             <>
                                 <TableRow key={row?._d?.npi_id} className="bg-gray-50 no-border">
                                     <TableCell className='table-row-data no-border' >
                                         {row?._d_?.npi_id || ''}
                                     </TableCell>
                                     <TableCell className='table-row-data no-border' >
                                        {[row?._d_?.first_name, row?._d_?.middle_name, row?._d_?.last_name].filter(Boolean).join(' ')}
                                     </TableCell>
                                     <TableCell className='table-row-data no-border' >
                                         {row?._d_?.city || ''}
                                     </TableCell>
                                     <TableCell className='table-row-data no-border' >
                                         {row?._d_?.state || ''}
                                     </TableCell>
                                     <TableCell className='table-row-data no-border' >
                                         {row?._d_?.district || ''}
                                     </TableCell>
                                 </TableRow>
                             </>
                         ))}
                     </TableBody>
                 </Table>
             </TableContainer>
         </Box>
        )
    }

    const renderAuditHistoryComponent = () => {
        return (
            <Box className='flex-column padding-0 gap-24'>
                {total_preview > 0 ? null : <Box className="flex-row center-align border-1-gray-300 br-12px gap-12 padding-12px bg-#FCFCFD">
                    <Box className='flex-row-start-center gap-6'>
                        <Typography className='gray-900 text-md-medium'>
                            Note:
                        </Typography>
                        <Typography className='engagement-title'>
                            The current query definition does not provide any valid results. Please revise your query parameters.
                        </Typography>
                    </Box>
                    <Box className='padding-10px'>
                        <CloseIcon color="#98A2B3" width='20' height='20' />
                    </Box>

                </Box>
                }
                {renderPreviewTable()}
            </Box>
        )
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
        <Grid 
            container
            className='modal_main'
        >
            <Grid item xs={12}>
                <Box className="padding-24px">
                    {/* Create new query */}
                    <Box className="flex-row-space-between pb-24px" >
                        <Typography className='text-lg-medium gray-900'>
                            {title}
                        </Typography>
                        <Box className="cursor-pointer" onClick={handleClose}>
                            <CloseIcon color="#98A2B3" width='12' height='12' />
                        </Box>
                    </Box>

                    {/* Query Name */}
                <Box className="flex-column gap-6 pb-24px w-100">
                    <Typography className='metrics-dropdown-title'>
                            Query Name
                    </Typography>
                        <input 
                                type="text"
                                placeholder='Query Name'
                                className='query_name-input-field'
                                
                                onChange={(e)=> handleNameChange(e.target.value)}
                                {...register('name')}
                        />
                    <span className="text-xs-regular error-500">
                        {errors.name?.message}
                    </span>
                    </Box>
                    {/* Query Builder component */}
                <Box>
                {queryRows?.map((row, index) => (
                    <QueryBuilders
                        key={row.id}
                        condition={index > 0 ? row.condition : null}
                        queryData={[{id:row.id}]}
                        rows={row}
                        selected={row}
                        onTriggerRowChange={handleRowChange}
                        index={index}
                        handleRowDelete={()=>deleteRow(row.id)}
                    />
                ))}
                </Box>
                    {/* Add Row  */}
                <Box className="padding-tb-24-rl-0 flex-row-space-between-center">
                        {/* Add Row */}
                        <Box  className="flex-row gap-8">
                            <PlusIcon color='#667085' />
                            <Typography className='engagement-title'>
                                Add Row
                            </Typography>
                        </Box>
                        <Box className="min-width-50">
                            <CustomReactSelect
                                options={addOptions}
                                handleFilter={addRow}
                                placeholder={<div>Select One</div>}
                            />
                        </Box>
                    </Box>

                    <Divider className='border-1-gray' />

                    {/* Total Matches */}
                    <Box className="flex-row-start-center padding-tb-24-rl-0 gap-16">
                        <Typography className='metrics-dropdown-title'>
                            Total Matches:
                        </Typography>
                        <Typography className='gray-900 text-xl-regular'>
                            {total_preview}
                        </Typography>
                    </Box>

                    <Divider className='border-1-gray' />

                    {/* Query Results Preview */}
                    <Box>
                        <CustomAccordion
                            title="Query Results Preview"
                            component={renderAuditHistoryComponent()}
                            acoordianDetailsBackground="bg-gray-50"
                            byDefaultOpen={false}
                            iconColor = "#344054"
                        
                        />
                    </Box>
                <Divider className='border-1-gray mb-4' />
                {Object.keys(query).length > 0 && query?.id &&
                    <CustomAccordion
                        title="Trigger Audit History"
                        component={<QueryAuditHistory trigger={query} />}
                        acoordianDetailsBackground="bg-gray-50"
                        byDefaultOpen={false}
                        iconColor = "#344054"
                    />
                }
                </Box>
            </Grid>

            <Grid 
                item 
                xs={12} 
                className='custom-modal-sticky-container'>
                <Divider className='border-1-gray'/>
                <Box className='flex-row-end-center gap-12 padding-tb-16-rl-24'>
                    <CustomButton
                        title="Cancel"
                        handleClick={handleClose}
                    />
                    <CustomButton
                        title="Save"
                        titleColor="#FFFFFF"
                        buttonColor="#AD509E"
                        handleClick={()=> handleSave()}
                        type="submit"
                    />
                </Box>
            </Grid>
        </Grid>
        </form>
    )
}

export default CreateQuery;